// extracted by mini-css-extract-plugin
export var content = "LocationInformation-module--content--3750d";
export var image = "LocationInformation-module--image--fc1ef";
export var wrapper = "LocationInformation-module--wrapper--d521e";